<template>
  <div class="page_outpost">
    <h1>{{ outpost.id }} - {{ outpost.city }}</h1>
    <label>Adresa:</label>
    <inputer class="address" :paths="['outpost', 'address']" :lineCount="3" name="Adresa" />
    <label>Jméno velitele:</label>
    <inputer class="leader" :paths="['outpost', 'leader', 'name']" name="Jméno velitele" />
    <label>Telefon velitele:</label>
    <inputer class="phone" :paths="['outpost', 'leader', 'phone']" name="Telefon velitele" />
    <label>E-mail velitele:</label>
    <inputer class="email" :paths="['outpost', 'leader', 'email']" name="E-mail velitele" />
    <label>Zodpovědná osoba pro RangerCamp je velitel:</label>
    <checkInputer :paths="['outpost', 'responsiblePerson', 'isLeader']" />
    <div v-if="!outpost.responsiblePerson.isLeader" class="responsible">
      <selectInputer :paths="['outpost', 'responsiblePerson', 'id']" :items="validResponsible">
        <template v-slot:default="props">{{ typeof props.label === 'string' ? props.label : `${props.label.name} ${props.label.surname}` }}</template>
        <template v-slot:item="props">{{ props.item.name }} {{ props.item.surname }}</template>
      </selectInputer>
      <label>Telefon zodpovědné osoby:</label>
      <inputer :paths="['outpost', 'responsiblePerson', 'phone']" name="Telefon zodpovědné osoby" />
      <label>E-mail zodpovědné osoby:</label>
      <inputer :paths="['outpost', 'responsiblePerson', 'email']" name="E-mail zodpovědné osoby" />
    </div>
    <form @submit="changePassword">
      <h2>Změna hesla</h2>
      <label for="oldPassword">Staré heslo:</label>
      <input type="password" id="oldPassword" v-model="oldPassword" />
      <label for="newPassword">Nové heslo:</label>
      <input type="password" id="newPassword" v-model="newPassword" />
      <label for="newPasswordConfirm">Nové heslo znovu:</label>
      <input type="password" id="newPasswordConfirm" v-model="newPasswordConfirm" />
      <button>Změnit heslo</button>
    </form>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { _ } from '../extend';
import inputer from "../components/inputer";
import checkInputer from "../components/inputer-check";
import selectInputer from "../components/inputer-select";

export default {
  name: "outpost",
  components: {
    inputer,
    checkInputer,
    selectInputer
  },
  data: () => ({
    oldPassword: "",
    newPassword: "",
    newPasswordConfirm: "",
  }),
  computed: {
    ...mapState(["outpost"]),
    validResponsible() {
      return _.filter(this.$store.state.participants, participant => participant.playingOutpostId == this.outpost.id && (participant.categoryId == 'royalRanger' || participant.categoryId == 'senior'));
    }
  },
  methods: {
    changePassword(ev) {
      ev.preventDefault();
      
      if (this.newPassword != this.newPasswordConfirm) {
        this.$store.commit("notify", { text: "Nová hesla se neshodují!", level: "warning" });
        return;
      }

      this.$store.dispatch("changePassword", { oldPassword: this.oldPassword, newPassword: this.newPassword });
      this.oldPassword = "";
      this.newPassword = "";
      this.newPasswordConfirm = "";
    }
  }
};
</script>

<style lang="sass">
@import ../sass/_components

.page_outpost
  width: 50%
  min-width: 700px
  margin: 0 auto
  .inputer, .inputer-select
    margin-bottom: 2rem
  .inputer-check
    display: inline-flex
    margin: 0 10px
  form
    display: grid
    h2
      margin-top: 2rem
      margin-bottom: 1rem
    input
      display: block
      margin-bottom: 2rem
      @include input-base()
    button
      @include button-primary()
      width: 10rem
      justify-self: center
</style>